<template>
  <div>
    <div class="w-28 h-28 overflow-hidden" v-if="!formLoading">
      <img
        class="block w-full h-full object-contain"
        src=""
        alt=""
        v-jw-load-img="getMediaURL(form)">
    </div>
    <p class="flex justify-center w-full mt-2">
      <i class="iconfont icon-weixin"></i>
      <span class="park-name text-center">微信扫码入驻{{ currentParkName }}</span>
    </p>
    <span class="text-center">九问数智企服小程序</span>
    <el-button
      ref="elButtonRef"
      class="jw-el-button mt-2"
      type="primary"
      :data-clipboard-text="form.scene"
      @click="onCopy">复制链接
    </el-button>
    <span class="mt-2">扫码入驻或发送邀请链接</span>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      formLoading: true,
      form: {
        prefixUrl: '',
        serviceFileName: '',
        scene: ''
      }
    }
  },
  computed: {
    ...mapGetters(['currentParkName'])
  },
  async mounted() {
    await this.init()
    this.formLoading = false
  },
  methods: {
    async init() {
      const { code, data } = await this.$fetch(`/api/park/parkOrg/currentParkQrcode`, {}, 'get')
      if (code === 20000 && !!data) {
        const { fileInfoBo, scene } = data
        for (const key in fileInfoBo) {
          if (this.form.hasOwnProperty(key)) {
            let value = fileInfoBo[key]

            if ((Array.isArray(value) && value.length >= 1) || (Object.prototype.toString.call(value) === '[object Object]') || (typeof value === 'string' && value) || typeof value === 'number' || typeof value === 'boolean') {
              this.$set(this.form, key, value)
            }
          }
        }

        this.$set(this.form, 'scene', scene)
      }
    },
    onCopy(event) {
      const clipboard = new ClipboardJS(this.$refs.elButtonRef.$el)

      clipboard.on('success', () => {
        this.$message.success('复制成功')
        clipboard.destroy()
      })

      clipboard.on('error', () => {
        this.$message.error('复制失败')
        clipboard.destroy()
      })

      clipboard.onClick(event)
    }
  }
}
</script>

<style scoped lang="scss">
.iconfont.icon-weixin {
  color: #5fc157;
}

.park-name {
  width: calc(100% - 22px);
}
</style>
